module.exports = __webpack_public_path__ + "media/5.043a522a.wav";